import { render } from "./PosPage.vue?vue&type=template&id=71488b6a&scoped=true&ts=true"
import script from "./PosPage.vue?vue&type=script&lang=ts"
export * from "./PosPage.vue?vue&type=script&lang=ts"

import "./PosPage.vue?vue&type=style&index=0&id=71488b6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71488b6a"]])

export default __exports__